import apiClient from "./api";

// 获取客户收货地址列表
export function getAddressesList() {
    return apiClient.get(`/v1/customer/addresses`);
}

// 添加新的客户收货地址
export function createAddress(data) {
    return apiClient.post(`/v1/customer/addresses`, data);
}

// 获取客户地址详情
export function getAddressDetail(id) {
    return apiClient.get(`/v1/customer/addresses/${id}`);
}

// 更新客户收货地址
export function updateAddress(id, data) {
    return apiClient.patch(`/v1/customer/addresses/${id}`, data);
}

// 删除客户收货地址
export function deleteAddress(id) {
    return apiClient.delete(`/v1/customer/addresses/${id}`);
}
